import api from "../api/axios";

const MESSAGE_REQUEST_TIMEOUT_MS = 12000;

function isRetryable(error) {
  if (error?.code === "INVALID_CHAT_PAGE") return true;
  const status = Number(error?.response?.status || 0);
  return !status || status === 408 || status === 425 || status === 429 || status >= 500;
}

export async function loadChatMessagePage(baseUrl, limit, { signal } = {}) {
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await api.get(`${baseUrl}/messages/`, {
        params: { limit },
        timeout: MESSAGE_REQUEST_TIMEOUT_MS,
        signal,
      });
      const messages = response?.data?.messages;
      const lastMessageId = Number(response?.data?.meta?.last_message_id || 0);
      if (!Array.isArray(messages) || (messages.length === 0 && lastMessageId > 0)) {
        const error = new Error("Chat message page is incomplete");
        error.code = "INVALID_CHAT_PAGE";
        throw error;
      }
      return response;
    } catch (error) {
      if (signal?.aborted || attempt === 1 || !isRetryable(error)) throw error;
    }
  }
  throw new Error("Chat message request exhausted retries");
}
